import React, {useEffect, useRef, useState} from "react";
import {useLoggedInStatus} from "../../../hooks";
import Container from "../Container";
import {Button, CustomLink, Image} from "../../common";
import {RouteDictionary} from "../../../utils";
import {LogoImage} from "../../common/images/types";
import {LogoType} from "../../common/images/types/LogoImage";
import ProfileMenu from "../../user/profile/ProfileMenu";
import cross from 'assets/images/svg/cross-enter.svg';
import styles from "./HeaderNew.module.scss";
import {useWindowWidth} from "../../pages/detailed-project/hooks";

export const HeaderPublic = () => {
  const isLoggedIn = useLoggedInStatus();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const isMobile = useWindowWidth();

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  return <header className={`${styles.header} ${styles['header--public']}`}>
    <Container>
      <div className={`${styles.logo__container} ${styles['logo__container--public']}`}>
        <CustomLink to={RouteDictionary.INDEX}>
          <LogoImage className={styles.logo} type={isMobile? LogoType.CONE: LogoType.HEADER}/>
        </CustomLink>
        <div className={styles.public__nav__right}>
          { !isLoggedIn ?
            <>
              <CustomLink to={RouteDictionary.HOW_IT_WORKS} className={styles.howItWorks}>
                Как это работает
              </CustomLink>
              <div className={styles.public} ref={dropdownRef}>
                <Button 
                  className={`${styles.public__buttonEnter} ${isDropdownOpen ? styles.public__buttonEnter__active : ''}`}
                  onClick={toggleDropdown}
                >
                  Личный кабинет
                </Button>
                <div className={`${styles.public__dropdown} ${isDropdownOpen ? styles.public__dropdown__open : ''}`}>
                  <CustomLink 
                    to={RouteDictionary.ENTER} 
                    className={styles.public__dropdown__item}
                  >
                    войти как инвестор
                    <button 
                      className={styles.public__dropdown__close}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        closeDropdown();
                      }}
                    >
                      <Image src={cross} alt='close'/>
                    </button>
                  </CustomLink>
                  <CustomLink 
                    to={RouteDictionary.ENTER_BORROWER} 
                    className={styles.public__dropdown__item}
                  >
                    войти как заемщик
                  </CustomLink>
                </div>
              </div>
            </>
            :
            <div className={styles.user__menu}>
              <ProfileMenu/>
            </div>}
        </div>
      </div>
    </Container>
  </header>;
};
